export default {
  bindings: {},
  template: require('./welcome.html')
};